import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button, Center, Flex, Heading, HStack, List, ListIcon, ListItem, SimpleGrid, Text, VStack } from '@chakra-ui/react'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { TVChartContainer } from '../AppComponents/AppComponentChart/AppComponentChartBasic';
import { TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons'
import TradingViewWidget, { Themes,IntervalTypes } from 'react-tradingview-widget';
import colors from '../../Utils/colors';
import AuthContext from '../../Routes/hooks/AuthContext';
import { MdCheckCircle } from 'react-icons/md';
import { db } from '../../Configs/firebase';
import { collection, getDocs, query } from 'firebase/firestore';
import moment from 'moment';
import { Rupiah } from '../../Utils/NumberUtils';

function AppBarNoPayment() {

    const [tab,setTab]=useState('overview')
    const exchange = "FLOW"
    const symbol = "USDT"
	const [price, setPrice] = useState(0)

	const timeNow = moment(new Date()).unix()*1000
	

	const { currentUser } = useContext(AuthContext);
	const navigate = useNavigate()

	const navigatePayment = () => {
	    navigate(`/payment/member/${currentUser.uid}`, {replace: true})
	}

	const getPayment = async () => {
			// get time
			const q = query(collection(db, "events"));
			const querySnapshot = await getDocs(q);
			let promoTime = []
			querySnapshot.forEach((doc) => {
				// data.push({file: doc.data()})
			const timeStart = doc.data().start
			const timeEnd = doc.data().end
			promoTime.push({'start':timeStart,   'end': timeEnd})
			});
			console.log(promoTime, 'timepromo')
			console.log(timeNow, 'timenow')

			// jika waktu sekarang === promo time start & promo time end buka 12jt
			for (const iterator of promoTime) {
			if(timeNow >= 1664110334526 && timeNow <= 1664110740000){
			setPrice({ price: 3500000});
			}else{
			setPrice({ price: 12000000});
			}
			}
	}

	useEffect(() => {
		getPayment()
	
	  return () => {
		
	  }
	}, [])
	
    
  return (
    <Box width='full' height='full' bgColor='black' color='white'>
		{/* <Alert status="error" bgColor="red.200">
			<AlertIcon color="red" />
			<AlertTitle  color="black">Kamu belum memiliki akses membership untuk mengakses fitur ini.</AlertTitle>
			<AlertDescription  color="black">Kamu dapat membeli membership terlebih dahulu.</AlertDescription>
		</Alert> */}
		<Box pt={5}>
                    <Heading textAlign="center" mt="5" fontSize="3xl">
                      Membership
                    </Heading>
					<Center>
                      <VStack bgColor="blackAlpha.800" spacing={3} m="2" p="10" borderStyle="solid" borderWidth="thin" borderRadius="3xl" >
                        <Heading fontSize="2xl">Member</Heading>
						{price.price === 3500000 ? (
							<>
							<Heading fontSize="2xl" as='del' color="red.300">{Rupiah(12000000)}</Heading>
							 <Heading fontSize="2xl">{Rupiah(price?.price)}</Heading>
							 </>
						) : (
							<Heading fontSize="2xl">{Rupiah(price?.price)}</Heading>
						)}
                        <List spacing={1}>
                          <ListItem mt="2">
                            <ListIcon as={MdCheckCircle} color="green.500" />
                            Akses analisis ++10.000 market
                          </ListItem>
                          <ListItem>
                            <ListIcon as={MdCheckCircle} color="green.500" />
                            Akses 1 tahun
                          </ListItem>
                          {/* <ListItem>
                            <ListIcon as={MdCheckCircle} color="green.500" />
                            Quidem, ipsam illum quis sed voluptatum quae eum fugit earum
                          </ListItem> */}
                        </List>
                        <Button bgColor="red" onClick={() =>  navigatePayment()}>
                          Beli
                        </Button>
                      </VStack>
					</Center>
                  </Box>
		<Center>
		<HStack pl='5' mt='5'>
			<Button color='green' ml='2' onClick={()=>setTab('overview')}>Overview</Button>
			<Button color='red' ml='2' onClick={()=>setTab('4chart')}>4 Chart</Button>
			<Button color='red' ml='2'>Patterns</Button>
			<Button color='red' ml='2'>News</Button>
		</HStack>

		</Center>
		
		<Box mt='5' >
			<Box >
			{/* <TVChartContainer /> */}
			{/* <TVChartContainer /> */}


  				{tab==='overview' &&
				  <>
				  <Box height='75vh' style={{ filter:  "blur(17px)" }} >

				  
				  <TradingViewWidget	
				  symbol={`${exchange}${symbol}`}
				  theme={Themes.DARK}
				  locale="en"
				  autosize
				  interval={IntervalTypes.H}
					/>
					</Box>
					</>
				  }
			</Box>
		</Box>

	</Box>
  )
}

export default AppBarNoPayment